import React from "react";

function ComingSoon() {
  return (
    <>
      <div style={{ textAlign: "center" }}>
        <br />
        <h1>{"Coming Soon"}</h1>
      </div>
    </>
  );
}

export default ComingSoon;
